import { UserRoles } from "../../data/enums";

// The Devices routes are role 100 only, while a non-admin with `terminal-list`
// also sees the Kiosks page (P-19). So the link to the paired fleet device
// exists only for an admin and only when the terminal is paired.
export const openDevicePath = (kiosk, roles = []) =>
  roles?.includes(UserRoles.ADMIN) && kiosk?.fleetdeviceid
    ? "/dashboard/devices/" + kiosk.fleetdeviceid
    : null;
